import { CascadeSelectDesignTokens } from '@primeuix/themes/types/cascadeselect';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/cascadeselect/index.ts
const cs = componentCommon.cascadeselect;

export const CascadeSelectTelekomDT: CascadeSelectDesignTokens = {
  root: {
    background: t(cs.background),
    color: t(cs.color),
    disabledBackground: t(cs.disabled.background),
    disabledColor: t(cs.disabled.color),
    filledBackground: t(cs.filled.background),
    filledHoverBackground: t(cs.filled.hover.background),
    filledFocusBackground: t(cs.filled.focus.background),
    borderColor: t(cs.border.color),
    borderRadius: t(cs.border.radius),
    hoverBorderColor: t(cs.hover.border.color),
    focusBorderColor: t(cs.focus.border.color),
    invalidBorderColor: t(cs.invalid.border.color),
    placeholderColor: t(cs.placeholder.color),
    invalidPlaceholderColor: t(cs.invalid.placeholder.color),
    paddingX: t(cs.padding.x),
    paddingY: t(cs.padding.y),
    focusRing: {
      width: t(cs.focus.ring.width),
      color: t(cs.focus.ring.color),
      offset: t(cs.focus.ring.offset),
    },
    sm: {
      fontSize: t(cs.sm.font.size),
      paddingX: t(cs.sm.padding.x),
      paddingY: t(cs.sm.padding.y),
    },
    lg: {
      fontSize: t(cs.lg.font.size),
      paddingX: t(cs.lg.padding.x),
      paddingY: t(cs.lg.padding.y),
    },
  },
  dropdown: {
    width: t(cs.dropdown.width),
    color: t(cs.dropdown.color),
  },
  overlay: {
    background: t(cs.overlay.background),
    borderColor: t(cs.overlay.border.color),
    borderRadius: t(cs.overlay.border.radius),
    color: t(cs.overlay.color),
  },
  list: {
    gap: t(cs.list.gap),
    padding: t(cs.list.padding.y),
  },
  option: {
    color: t(cs.option.color),
    focusBackground: t(cs.option.focus.background),
    focusColor: t(cs.option.focus.color),
    selectedBackground: t(cs.option.selected.background),
    selectedColor: t(cs.option.selected.color),
    selectedFocusBackground: t(cs.option.selected.focus.background),
    selectedFocusColor: t(cs.option.selected.focus.color),
    borderRadius: t(cs.option.border.radius),
    padding: t(cs.option.padding.y),
  },
  clearIcon: {
    color: t(cs.clear.icon.color),
  },
};
